import {
  FETCH_BUILDING_AREAS_REQUEST,
  FETCH_BUILDING_AREAS_SUCCESS,
  FETCH_BUILDING_AREAS_FAILURE,
  SAVE_BUILDING_AREA_REQUEST,
  SAVE_BUILDING_AREA_SUCCESS,
  SAVE_BUILDING_AREA_FAILURE,
  DELETE_BUILDING_AREA_REQUEST,
  DELETE_BUILDING_AREA_SUCCESS,
  DELETE_BUILDING_AREA_FAILURE,
} from './types';

const INITIAL_STATE = {
  buildingAreaList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BUILDING_AREAS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BUILDING_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        buildingAreaList: action.payload,
      };

    case FETCH_BUILDING_AREAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        buildingAreaList: [],
      };
    case SAVE_BUILDING_AREA_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_BUILDING_AREA_SUCCESS:
      return {
        ...state,
      };

    case SAVE_BUILDING_AREA_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_BUILDING_AREA_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_BUILDING_AREA_SUCCESS:
      return {
        ...state,
      };

    case DELETE_BUILDING_AREA_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
